import React, { Component } from "react";
import Constants from "../../Config/Config";
//import WindowDimensionsPopUp from '../Modal/WindowDimensionsPopUp';

class FramedSize extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.changeSize = this.changeSize.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.equalSpacing = this.equalSpacing.bind(this);

    this.state = {
      show: false,
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  equalSpacing() {
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        equalSpacing: true,
      },
    });
  }

  handleChange(e) {
    const target = e.target;
    const name = target.name;
    let value = name === "isGrid" ? target.checked : target.value;

    //if (parseFloat(value) <= 0 || value === "") value = 0;

    switch (name) {
      case "matOuterHeight":
        this.props.dispatch({
          type: "SET_STATE",
          state: {
            matOuterHeight: value,
            matOuterUpdated: this.props.matOuterUpdated === 1 ? 0 : 1,
          },
        });
        break;
      case "matOuterWidth":
        this.props.dispatch({
          type: "SET_STATE",
          state: {
            matOuterWidth: value,
            matOuterUpdated: this.props.matOuterUpdated === 1 ? 0 : 1,
          },
        });
        break;
      case "isGrid":
        this.props.dispatch({
          type: "SET_STATE",
          state: {
            isGrid: this.props.isGrid === true ? false : true,
          },
        });
        break;
      default:
    }
  }

  changeSize() {
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        matOuterUpdated: this.props.matOuterUpdated === 1 ? 0 : 1,
      },
    });

    const { matOuterWidth, matOuterHeight } = this.props;

    // Images size
    if (
      matOuterWidth < 20 ||
      matOuterWidth > 125 ||
      matOuterHeight < 20 ||
      matOuterHeight > 125
    ) {
      this.props.dispatch({
        type: "SET_STATE",
        state: {
          imageSizeError: true,
        },
      });
    } else {
      this.props.dispatch({
        type: "SET_STATE",
        state: {
          imageSizeError: false,
        },
      });
    }
  }

  render() {
    const { matOuterHeight, matOuterWidth, isGrid } = this.props;
    return (
      <div className="top_cont">
        <ul>
          <li className="frame-size-li">
            <p>Mat Outer Size:</p>
          </li>
          <li>
            <label>Width</label>
            <div className="quantity">
              <input
                step=".5"
                type="number"
                min="20"
                max="125"
                id="matOuterWidth"
                name="matOuterWidth"
                value={matOuterWidth}
                onChange={this.handleChange}
                className={
                  parseFloat(matOuterWidth) < 20 ||
                  parseFloat(matOuterWidth) > 125
                    ? "image-size-error"
                    : ""
                }
              />
            </div>
          </li>
          <li>
            <label>Height</label>
            <div className="quantity">
              <input
                type="number"
                step=".5"
                min="20"
                max="125"
                id="matOuterHeight"
                name="matOuterHeight"
                value={matOuterHeight}
                onChange={this.handleChange}
                className={
                  parseFloat(matOuterHeight) < 20 ||
                  parseFloat(matOuterHeight) > 125
                    ? "image-size-error"
                    : ""
                }
              />
            </div>
          </li>
        </ul>
        <div className="clear m-t-5"></div>
        <div className="row">
          <div className="col-sm-8">
            <p>
              Min: {Constants.MIN_IMAGE_DIMENSIONS_CM} cm, Max:{" "}
              {Constants.MAX_IMAGE_DIMENSIONS_CM} cm
            </p>
          </div>
          {/* <div className="col-sm-4" style={{textAlign: 'center'}}>
            <input type="button" value="Change Size" onClick={this.changeSize} className="btn btn-primary default-btn" />
          </div> */}
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="isGrid"
            id="isGrid"
            checked={isGrid}
            onChange={this.handleChange}
          />{" "}
          <label className="form-check-label" htmlFor="isGrid">
            0.5MM Grid Lines
          </label>
        </div>
        {/* <div className="clear m-t-5"></div>
        <div className="equal-spacing">
          <button
            type="button"
            className="btn btn-primary default-btn"
            onClick={this.equalSpacing}>
            Equal Spacing
          </button>
        </div> */}
        <div className="clear m-t-5"></div>
        {/* <div className="row">
          <div className="col-sm-12">
            <p><a href="#!" onClick={this.handleShow}>Mat Window Dimensions</a></p>
            <WindowDimensionsPopUp {...this.props} show={this.state.show} onHide={this.handleClose} />
          </div>
        </div> */}
      </div>
    );
  }
}
export default FramedSize;
